import { MdCheckCircle } from "react-icons/md";
import SideIndicator from "assets/icons/admin-view/SideIndicator";

interface ProgressItemProps {
  index: number;
  currentStep: number;
  text: string;
}

interface ProgressMapProps {
  stage: number;
  steps: string[];
}

/**
 * Progress item definition
 * @param
 * @returns
 */
const ProgressItem: React.FC<ProgressItemProps> = ({
  index,
  currentStep,
  text,
}) => {
  return (
    <div className="inline-flex items-center">
      <div className="px-1">
        {currentStep === index ? <SideIndicator /> : <div className="px-1" />}
      </div>
      <div
        className={`w-full h-fit p-3 rounded-3xl flex-col justify-start items-center gap-2 flex ${
          currentStep === index ? "bg-neutral-700" : "bg-transparent"
        }`}
      >
        <div
          className={`w-[33px] h-[33px] px-[13.50px] pt-[9px] pb-2 ${
            currentStep === index ? "bg-white" : "bg-neutral-50"
          } rounded-full flex-col justify-center items-center gap-2 flex`}
        >
          <div
            className={`text-base font-semibold font-sans leading-[19px] ${
              currentStep === index ? "text-neutral-700" : "text-neutral-400"
            }`}
          >
            {index}
          </div>
          {currentStep > index && (
            <MdCheckCircle
              className="absolute w-5 h-5 fill-success-500 rounded-full bg-white"
              style={{ transform: "translateX(15px) translateY(-15px)" }}
            />
          )}
        </div>
        <div className="justify-center items-center gap-2 inline-flex">
          <div
            className={`grow shrink basis-0 text-center text-base font-normal font-sans leading-[19px] ${
              currentStep === index ? "text-white" : "text-neutral"
            }`}
          >
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Progress map element
 * @returns
 */
const ProgressMap: React.FC<ProgressMapProps> = ({ stage, steps }) => {
  return (
    <div className="absolute h-fit items-start justify-center mt-auto mb-auto left-[75%] top-1/3 flex flex-col">
      <div className="w-[150px] h-fit rounded-3xl flex-col flex gap-12">
        {steps &&
          steps.length > 0 &&
          steps.map((text: string, index: number) => {
            return (
              <ProgressItem
                key={index}
                index={index + 1}
                currentStep={stage}
                text={text}
              />
            );
          })}
      </div>
    </div>
  );
};

export default ProgressMap;
